import {
  PRICING_POPUP_ALLOW,
  PRICING_SET_ACTIVE_SORT_TAB,
  PRICING_SET_CATALOGS,
  PRICING_SET_CUSTOM_GROUP_NAMES,
  PRICING_SET_FEATURES_LIST,
  PRICING_SET_FEATURES_RECEIVED,
  PRICING_SET_NOTIFICATION,
  PRICING_SET_SEARCH_TEXT,
  PRICING_SHOW_PRICING_POPUP,
  PRICING_SET_FEATURES_COLUMNS,
  PRICING_SET_FEATURE_GROUPS_CHECKED,
  PRICING_SET_GROUP_NAME,
  PRICING_SET_EDITED_FEATURES
} from "../../constants/actionTypes";

export const setPricingGroupName = (pricingGroupName) => ({
  type: PRICING_SET_GROUP_NAME,
  payload: {pricingGroupName}
})

export const setPricingSearchText = (pricingSearchText) => ({
  type: PRICING_SET_SEARCH_TEXT,
  payload: {pricingSearchText}
})

export const setPriceListActiveSortTab = (priceListActiveSortTab) => ({
  type: PRICING_SET_ACTIVE_SORT_TAB,
  payload: {priceListActiveSortTab}
})

export const setAllowPricingPopups = (allowPricingPopups) => ({
  type: PRICING_POPUP_ALLOW,
  payload: {allowPricingPopups}
})

export const showPricingPopup = (pricingPopupOpened, pricingPopupType) => ({
  type: PRICING_SHOW_PRICING_POPUP,
  payload: {pricingPopupOpened, pricingPopupType}
})

export const setPricingNotification = (visible = false, type = "", text = "") => ({
  type: PRICING_SET_NOTIFICATION,
  payload: {visible, type, text}
})

export const setPricingCustomGroupNames = (groupName, customGroupName) => ({
  type: PRICING_SET_CUSTOM_GROUP_NAMES,
  payload: {groupName, customGroupName}
})

export const setPricingCatalogs = (pricingCatalogs) => ({
  type: PRICING_SET_CATALOGS,
  payload: {pricingCatalogs}
})

export const setPricingFeaturesReceived = (pricingFeaturesReceived) => ({
  type: PRICING_SET_FEATURES_RECEIVED,
  payload: {pricingFeaturesReceived}
})

export const setPricingFeaturesList = (pricingFeaturesList) => ({
  type: PRICING_SET_FEATURES_LIST,
  payload: {pricingFeaturesList}
})

// export const updatePricingFeatures = () => ({
//   type: PRICING_UPDATE_FEATURES_COUNT,
// })

export const setPricingFeaturesColumns = (pricingFeaturesColumns) => ({
  type: PRICING_SET_FEATURES_COLUMNS,
  payload: {pricingFeaturesColumns}
})

export const setPricingFeatureGroupsChecked = (pricingFeatureGroupsChecked) => ({
  type: PRICING_SET_FEATURE_GROUPS_CHECKED,
  payload: {pricingFeatureGroupsChecked}
})

export const pricingEditFeature = (event) => {
  return (dispatch, getState) => {
    let {pricingEditedFeatures} = getState().pricingState;
    // console.log("edit event", event.target.name, event.target.value, event.target.dataset.id);
    if (!pricingEditedFeatures[event.target.dataset.id]) {
      pricingEditedFeatures[event.target.dataset.id] = {
        fabricatorFeatureIds: event.target.dataset.ids
          ? event.target.dataset.ids.split(",").map(string => +string)
          : null
      }
    }
    pricingEditedFeatures[event.target.dataset.id] = {
      ...pricingEditedFeatures[event.target.dataset.id],
      [event.target.name]: event.target.value
    };
    if (event.target.value === event.target.dataset.default) {
      delete pricingEditedFeatures[event.target.dataset.id][event.target.name];
    }
    dispatch(setPricingEditedFeatures({...pricingEditedFeatures}))
  }
}

export const setPricingEditedFeatures = (pricingEditedFeatures) => ({
  type: PRICING_SET_EDITED_FEATURES,
  payload: {pricingEditedFeatures}
})
